"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpreadsheetFooterType = exports.TextInputType = exports.InputType = void 0;
var InputType;
(function (InputType) {
    InputType["ADDRESS"] = "address";
    InputType["ADDRESS_OR_STATE"] = "address-or-state";
    InputType["CALENDAR_DATE"] = "calendardate";
    InputType["CHECKBOX"] = "checkbox";
    InputType["CURRENCY"] = "currency";
    InputType["CURRENCY_APPLIES"] = "currencyapplies";
    InputType["CURRENCY_PERCENTAGE"] = "currencypercentage";
    InputType["CURRENCY_WITH_NUMBER"] = "currencywithnumber";
    InputType["CURRENCY_WITH_TYPE"] = "currencywithtype";
    InputType["DATE"] = "date";
    InputType["MULTI_SELECT"] = "multiselect";
    InputType["NUMBER"] = "number";
    InputType["RADIO"] = "radio";
    InputType["SELECT"] = "select";
    InputType["PERCENTAGE"] = "percentage";
    InputType["TEXT"] = "text";
    InputType["TEXT_AREA"] = "textarea";
    InputType["NESTED_SCHEMA"] = "nested-schema";
    InputType["EMBEDDED_COVERAGE"] = "embedded-coverage";
})(InputType = exports.InputType || (exports.InputType = {}));
var TextInputType;
(function (TextInputType) {
    TextInputType["TEXT"] = "TEXT";
    TextInputType["TEXT_AREA"] = "TEXT_AREA";
})(TextInputType = exports.TextInputType || (exports.TextInputType = {}));
var SpreadsheetFooterType;
(function (SpreadsheetFooterType) {
    SpreadsheetFooterType["AVERAGE"] = "AVERAGE";
    SpreadsheetFooterType["SUM"] = "SUM";
})(SpreadsheetFooterType = exports.SpreadsheetFooterType || (exports.SpreadsheetFooterType = {}));
//# sourceMappingURL=common.js.map